<ng-form class="k-form k-form-md" [formGroup]="appPowderData" style="margin-top: 10px;">
    <fieldset>
        <legend style="border-bottom: 1px solid #e2e8f0;">Powder/Binder Parameters</legend>
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-4">
                <kendo-formfield>
                    <kendo-label for="standardPowderSet">Standard Powder Set(s)</kendo-label>
                    <kendo-dropdownlist id="standardPowderSet" name="standardPowderSet"
                        formControlName="standardPowderSet" [data]="getStandardPowderSets()" textField="name" valueField="name"></kendo-dropdownlist>
                    <kendo-formhint style="color:darkcyan;">Populate powders from set</kendo-formhint>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-2">
                <kendo-formfield>
                    <kendo-label for="FACE">Face Powder</kendo-label>
                    <kendo-dropdownlist id="FACE" formControlName="FACE" [valuePrimitive]="true" 
                        name="FACE" [data]="FacePowder_Data" textField="name" valueField="name"></kendo-dropdownlist>
                    <kendo-formerror>Error: Face powder is required</kendo-formerror>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-2">
                <kendo-formfield>
                    <kendo-label for="GAUGE">Gauge Powder</kendo-label>
                    <kendo-dropdownlist id="GAUGE" formControlName="GAUGE" [valuePrimitive]="true" 
                        name="GAUGE" [data]="GaugePowder_Data" textField="name" valueField="name"></kendo-dropdownlist>
                    <kendo-formerror>Error: Gauge powder is required</kendo-formerror>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-2">
                <kendo-formfield>
                    <kendo-label for="MACHINABLE">Machinable Powder</kendo-label>
                    <kendo-dropdownlist id="MACHINABLE" formControlName="MACHINABLE" [valuePrimitive]="true" 
                        name="MACHINABLE" [data]="MachinablePowder_Data" textField="name" valueField="name"></kendo-dropdownlist>
                    <kendo-formerror>Error: Machinable powder is required</kendo-formerror>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-2">
                <kendo-formfield>
                    <kendo-label for="BINDER">Binder</kendo-label>
                    <kendo-dropdownlist id="BINDER" formControlName="BINDER" name="BINDER" [data]="Binder_Data" textField="name" valueField="name" [valuePrimitive]="true" ></kendo-dropdownlist>
                    <kendo-formerror>Error: Binder is required</kendo-formerror>
                </kendo-formfield>
            </div>
        </div>
    </fieldset>
</ng-form>